var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iap-label",class:_vm.has_iap_data ? 'iap-enabled' : 'iap-disabled'},[_vm._v("IAP")])}
var staticRenderFns = []

export { render, staticRenderFns }